import { Table, Button, Popover, Space } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EditButton from "../UI/EditButton/editbutton";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { BarcodeOutlined, RedoOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";
import { format } from "date-fns";
interface ReturnedDataProps {
  isReturnedDataLoading: boolean;
  returnedData: [] | undefined;
  setReturnedData: Dispatch<SetStateAction<[] | undefined>>;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  ReturnedDataMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
    },
    unknown
  >;
  search: string;
  tableKey: string;
}
interface ReturnInterface {
  key: React.Key;
  date: string;
  invoices: string;
  bill: string;
  Activetime: string;
  amount: string;
  currency: string;
  rate: string;
}
const ReturnList = ({
  isReturnedDataLoading,
  returnedData,
  setReturnedData,
  page,
  setPage,
  ReturnedDataMutation,
  search,
  tableKey,
}: ReturnedDataProps) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();
  const content = <div>{t("barcode")}</div>;
  const returned = <>{t("returned")}</>;
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);

  const DeletePrice = (id: string | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };

  const handleOk = () => {
    setOpen(false);
  };

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      ReturnedDataMutation({
        limit: page * 10 + 10,
        q: search,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setReturnedData(res.data.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns: ColumnsType<ReturnInterface> = [
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      width: "10rem",
      className: "table-header",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("invoices")}`,
      dataIndex: "invoiceNo",
      key: "invoiceNo",
      width: "10rem",
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
      width: "10rem",
    },
    {
      title: `${t("rate")}`,
      dataIndex: "exchangeRate",
      key: "exchangeRate",
      width: "8rem",
    },

    {
      title: `${t("currency")}`,
      dataIndex: "currency",
      key: "currency",
      width: "12rem",
      render: (record: any) => {
        return record ? record.name : null;
      },
    },
    {
      title: `${t("note")}`,
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "10rem",
      align: "center" as "center",
      render: (record: any) => (
        <>
          <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              className="Button"
              type="text"
              icon={
                <BarcodeOutlined
                  style={{ color: "#212121", fontSize: "14px" }}
                />
              }
            ></Button>
          </Popover>
          <Popover content={returned} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              type="text"
              className="Button"
              onClick={() => navigate(`/returninvoices/${record?.id}`)}
              icon={
                <RedoOutlined style={{ color: "#212121", fontSize: "14px" }} />
              }
            />
          </Popover>
          <EditButton
            onClick={() => {
              navigate(`/return/${record?.id}`);
            }}
          />
          <DeleteButton
            onClick={() => {
              DeletePrice(record?.id, record?.name);
            }}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      <Table
        key={tableKey}
        scroll={{ x: 1000 }}
        loading={isReturnedDataLoading}
        columns={columns}
        dataSource={returnedData}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record: any) => record.id}
      />
    </>
  );
};

export default ReturnList;
